module.exports = __webpack_public_path__ + "static/media/vehicle-tracking-sound.9d8d3222.mp3";